import { Dialog } from "@material-ui/core";
import * as React from "react";
import CloseIcon from "src/documentUpload/close.svg";
import QuiqButton from "src/shared/QuiqButton";
import WarningIcon from "src/spread/chartOfAccounts/warning-icon.svg";

export interface DeleteRuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteRuleModal: React.SFC<DeleteRuleModalProps> = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="ConfirmModal"
      PaperProps={{ className: "ConfirmModal__paper" }}
      transitionDuration={0}
      disableBackdropClick={true}
    >
      <img
        src={CloseIcon}
        onClick={onClose}
        className="ConfirmModal__closing-icon"
      />
      <img src={WarningIcon} className="ConfirmModal__warning-icon" />
      <div className="ConfirmModal__header">Remove Rule</div>
      <div className="ConfirmModal__content">
        Removing this rule means that it will not be automatically applied the
        next time you spread this entity
      </div>
      <div className="ConfirmModal__button__container">
        <QuiqButton
          onClick={onClose}
          variant="text"
          className="ConfirmModal__button__cancel"
        >
          CANCEL, KEEP RULE
        </QuiqButton>
        <QuiqButton
          onClick={onConfirm}
          color="blue"
          className="ConfirmModal__button__confirm"
        >
          YES, REMOVE RULE
        </QuiqButton>
      </div>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/ruleView/DeleteRuleModal.tsx